export enum EntityType {
  Page = 'page',
}
